<template lang="pug">
.peopleRadioDialog
    el-form.demo-form-inline(:inline='true', :model='searchlist', size='mini') 
        el-form-item(label='机构类型选择：' )  
            el-cascader(ref='searchArea',:props="optionProps" :options='searchGroups', v-model='searchlist.trackPersonName', @change='handleChange', style='width:250px',)
    el-table(ref='peopleRadioDialogT', :data='tableData', :row-key="getRowKey",@selection-change="selectionChange",
     :header-cell-style="{ background: '#f8fafa' }", border='', align='center', current-row-key='', highlight-current-row='', 
      @select="handleSelectionsChange" @select-all="handleSelectionsChange")
        el-table-column(type='selection', align='center' ,:selectable="checkSelectable" )
        el-table-column(align='center', prop='name', label='姓名')
        el-table-column(align='center', prop='mobile', label='手机号')

    el-pagination(@size-change='handleSizeChange', @current-change='handleCurrentChange', :current-page='pageConfig.pageNo', :page-sizes='[10, 20, 30, 50]', :page-size='pageConfig.pageSize', layout='total, sizes, prev, pager, next, jumper', :total='pageConfig.total')

    .boontbtn
        el-button(type='primary', size='small', @click='createData', style='margin: 0 30px') 保存

</template>

<script>
import { OrgTreelist, getConsulTYpePersion } from "@/api/http.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "peopleRadioDialog",
  props: ["choosedata", "isshow", "personTypeF"],
  data() {
    return {
      optionProps: {
        value: "label",
        label: "label"
      },
      // 树形控件的配置
      defaultProps: {
        children: "children",
        label: "label"
      },
      //人员类别
      searchGroups: [],
      searchlist: {
        trackPersonId: "",
        trackPersonName: []
      },
      tableData: [],
      multipleSelection: {},
      chooseDatas: "",
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      getRowKey(row) {
        return row.id;
      },

      checkSelectable(row) {
        return true;
      },
      checkedData: [],
      currentPageData: [],
      multipleSelectionFarher: {},
      multipleSelectionClick: {}
      //   surplusData: []
    };
  },
  methods: {
    //条件筛选中，区域选择赋值
    handleChange(value) {
      //   console.log(this.$refs.searchArea.getCheckedNodes()[0].data);
      const areas = this.$refs.searchArea.getCheckedNodes()[0].pathLabels;
      const orgId = this.$refs.searchArea.getCheckedNodes()[0].data.orgId;
      //   this.searchlist.streetCode = areas[0] == "全部" ? "" : areas[0];
      this.searchlist.trackPersonId = orgId;
      this.getPageDatas();
    },

    async findTreelist() {
      // admin/partyOrgBuild/info/findPartyOrgBuildTreelist
      var res = await OrgTreelist({});
      if (!res.content) return;
      this.searchGroups = res.content.filter(it => it.orgType == "1");

      //   this.orgData = res.content;
    },

    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.checkedData = [];
      this.multipleSelection = {};
      this.multipleSelectionFarher = {};
      this.multipleSelectionClick = {};
      this.tableData = [];
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas() {
      const orgIds = this.searchlist.trackPersonId
        ? [this.searchlist.trackPersonId]
        : [];
      var res = await getConsulTYpePersion({
        pageNo: 1,
        pageSize: 10,
        orgIds: orgIds
      });

      // console.log(res)
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;
      } else {
        // console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    checkedTable() {
      //   console.log("checkedData==t", this.checkedData);
      this.$nextTick(() => {
        this.checkedData.forEach(checked => {
          this.$refs.peopleRadioDialogT.toggleRowSelection(checked, true);
        });
      });
    },

    handleSelectionsChange(val) {
      this.multipleSelectionClick[this.pageConfig.pageNo] = val.length + 1;
      this.multipleSelection[this.pageConfig.pageNo] = val;
      //   this.currentPageData = val;
    },
    selectionChange(val) {
      this.chooseDatas = val;
      if (val.length > 1) {
        this.$refs.peopleRadioDialogT.clearSelection();
        this.$refs.peopleRadioDialogT.toggleRowSelection(val.pop());
      }
    },
    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;

      this.getPageDatas();
    },
    //封装数据
    createData() {
      // console.log(this.chooseDatas);
      // if (!this.searchlist.trackPersonId) {
      //   this.$message({
      //     message: "请选择机构类型",
      //     type: "error"
      //   });
      //   return;
      // }
      if (this.chooseDatas && this.chooseDatas.length) {
        this.$emit("func", {
          trackPersonName:
            this.searchlist.trackPersonName.join(",") +
            "," +
            this.chooseDatas[0].name,
          trackPersonId: this.chooseDatas[0].id,
          peopleName: this.chooseDatas[0].name,
          persionPhone: this.chooseDatas[0].mobile,
        });
      } else {
        this.$message({
          message: "请选择一个人员",
          type: "error"
        });
      }
    }
  },
  computed: {
    disabledType() {
      if (this.personTypeF) return true;
      return false;
    }
  },
  mounted() {
    this.searchlist = {
      trackPersonId: "",
      trackPersonName: []
    };
    this.tableData = [];
    this.pageConfig.pageNo = 1;
    this.findTreelist();
    this.getPageDatas();
  },
  watch: {
    choosedata(val) {
      if (val && val.length) {
      } else {
        this.$refs.peopleRadioDialogT.clearSelection();
      }
    },
    isshow(val) {
      //   console.log(val);

      if (!val) {
        this.checkedData = [];
        this.chooseDatas = [];
        this.searchlist = {
          trackPersonId: "",
          trackPersonName: []
        };
        this.tableData = [];
        this.pageConfig.pageNo = 1;
      } else {
        this.findTreelist();
        this.getPageDatas();
      }
    }
  }
};
</script>

<style lang="less" >
.peopleRadioDialog {
  .boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .has-gutter .el-table-column--selection .cell {
    display: none !important;
  }
}
</style>